
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { DayOfWeek } from '@/models/Schedule';
import {
  createTimeSlotSchema,
  TimeSlotFormData,
} from '../timeSlotFormSchema';

interface UseTimeSlotFormInitializationProps {
  preselectedDay?: DayOfWeek;
  open: boolean;
}

export const useTimeSlotFormInitialization = ({
  preselectedDay,
  open,
}: UseTimeSlotFormInitializationProps) => {
  const form = useForm<TimeSlotFormData>({
    resolver: zodResolver(createTimeSlotSchema()),
    defaultValues: {
      selectedDays: [],
      workoutTypeId: '',
      startTime: '',
      endTime: '',
      maxClients: 10,
      autoEndTime: false,
      isRecurringMode: false,
      recurringStartTime: '08:00',
      recurringEndTime: '20:00',
      recurringInterval: '60',
      slotDuration: '60',
    },
  });

  const isRecurringMode = form.watch('isRecurringMode');

  // Set preselected day when the modal opens
  useEffect(() => {
    if (open && preselectedDay) {
      form.setValue('selectedDays', [preselectedDay]);
    }
  }, [open, preselectedDay, form]);

  // Reset form when modal closes
  useEffect(() => {
    if (!open) {
      form.reset({
        selectedDays: [],
        workoutTypeId: '',
        startTime: '',
        endTime: '',
        maxClients: 10,
        autoEndTime: false,
        isRecurringMode: false,
        recurringStartTime: '08:00',
        recurringEndTime: '20:00',
        recurringInterval: '60',
        slotDuration: '60',
      });
    }
  }, [open, form]);

  return {
    form,
    isRecurringMode,
  };
};
